<template>
  <v-card :class="color" raised>
    <v-list-item :two-line="value === undefined">
      <v-list-item-avatar>
        <v-icon dark>{{ icon }}</v-icon>
        <v-icon small dark>{{ subIcon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="subheading font-weight-medium text-right white--text">{{ title }}</v-list-item-title>
        <v-list-item-subtitle v-if="value !== undefined" class="caption text-right white--text">{{ new Intl.NumberFormat().format(value) }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: 'StatCard',

  props: {
    color: {
      type: String,
      default: undefined
    },
    icon: {
      type: String,
      default: undefined
    },
    subIcon: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    },
    value: {
      type: Number,
      default: undefined
    }
  }
}
</script>
